// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2725f822","455":"c828fcff","977":"668c022d"}[chunkId] + ".chunk.js";
};